import { Component, HostListener, OnInit } from '@angular/core';
import { EBBClaimCountReportsModel } from 'src/Models/EBBClaimCountReportsModel';
import { FilterModel } from 'src/Models/filterModel';
import { CheckAuth } from 'src/Services/utility.service';
import { Title } from '@angular/platform-browser';
import { LifelineNLADClaimService } from 'src/Services/nladClaim.service';
import { InrollProductsCompanyModel } from 'src/Models/InrollProductsCompanyModel';
import { ClaimStateModel } from 'src/Models/ClaimStateModel';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import * as FileSaver from 'file-saver';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-admin-claim-summary-lifeline-reports',
  templateUrl: './admin-claim-summary-lifeline-reports.component.html',
  styleUrls: ['./admin-claim-summary-lifeline-reports.component.css']
})
export class AdminClaimSummaryLifelineReportsComponent implements OnInit {
  filterModel = new FilterModel();
  listOfData: EBBClaimCountReportsModel[];
  listOfExportData: EBBClaimCountReportsModel[];
  tokenKey: string = '';
  _userID: any;

  currentPage: number = 1;
  totalRecordCount: number = -1;
  keywordFilter: string = '';
  OrderBy: string = '';
  isAscending: boolean = false

  upDowCompanyNameCSS: string = '';
  upDowYearsCSS: string = '';
  upDowMonthsCSS: string = '';
  upDowTotalCountCSS: string = '';
  upDowTotalAmountCSS: string = '';
  upDowStateCSS: string = '';

  dropdownMonths = [];
  selectedItemsMonths = [];
  dropdownSettingMonths = {};
  listOfMonths = [];

  dropdownYears = [];
  selectedItemsYears = [];
  dropdownSettingYears = {};
  listOfYears = [];
  monthText = [];

  listOfInrollProductCompany: InrollProductsCompanyModel[];
  dropdownCompanies = [];
  selectedItemsCompanies = [];
  dropdownSettingCompanies = {};
  listOfCompany = [];

  listOfStateData: ClaimStateModel[];
  dropdownStates = [];
  selectedItemsStates = [];
  dropdownSettingStates = {};
  listOfStates = [];

  isShowprogressSpinner: boolean;
  blockedDocument: boolean = false;
  isloading: boolean = false;
  openMenuIndex: number = -1;

  constructor(private readonly nladClaimService: LifelineNLADClaimService,
    private readonly checkAuth: CheckAuth,
    private readonly titleService: Title,
    private readonly router: Router,
    private readonly toastr: ToastrService,
    private sessionStorageService: SessionStorageService
  ) {
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this._userID = sessionStorage.getItem('UserId');
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.titleService.setTitle('Lifeline Claim Summary');
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }
  ngOnInit() {
    this.totalRecordCount = 0;
    this.currentPage = 1;
    this.filterModel.pageNumber = '1';
    this.filterModel.pageSize = '10';
    this.filterModel.orderBy = 'CompanyName';
    this.filterModel.userID = this._userID;
    this.filterModel.productId = 0;
    this.filterModel.months = '0';
    this.filterModel.years = '0';
    this.filterModel.state = '0';
    this.GetMonths();
    this.GetYears();
    this.GetInrollClientCompany();
    this.GetClaimState();

    sessionStorage.removeItem('DetailReportsYear');
    sessionStorage.removeItem('DetailReportsMonths');
    sessionStorage.removeItem('DetailReportsProviderId');
    sessionStorage.removeItem('DetailReportsCompanyName');
    sessionStorage.removeItem('DetailReportsState');
    sessionStorage.removeItem('ReportFlag');

    this.monthText.push({ 'id': 1, 'itemName': 'January' });
    this.monthText.push({ 'id': 2, 'itemName': 'February' });
    this.monthText.push({ 'id': 3, 'itemName': 'March' });
    this.monthText.push({ 'id': 4, 'itemName': 'April' });
    this.monthText.push({ 'id': 5, 'itemName': 'May' });
    this.monthText.push({ 'id': 6, 'itemName': 'June' });
    this.monthText.push({ 'id': 7, 'itemName': 'July' });
    this.monthText.push({ 'id': 8, 'itemName': 'August' });
    this.monthText.push({ 'id': 9, 'itemName': 'September' });
    this.monthText.push({ 'id': 10, 'itemName': 'October' });
    this.monthText.push({ 'id': 11, 'itemName': 'November' });
    this.monthText.push({ 'id': 12, 'itemName': 'December' });
  }

  LifelineClaimSummaryReports() {
    this.blockDocument()
    this.listOfData = [];
    this.isloading = true;
    this.filterModel.IsExport = false;
    this.nladClaimService.LifelineClaimSummaryReports(this.tokenKey, this.filterModel).subscribe(
      data => {
        this.isloading = false;
        this.unblockDocument();
        if (data != null) {
          this.listOfData = data['listOfData'];
          if (this.listOfData != null) {
            if (this.listOfData.length > 0) {
              this.totalRecordCount = this.listOfData[0].totalRecords;
            }
            else
              this.totalRecordCount = 0;
          }
          else
            this.totalRecordCount = 0;
        }
      },
      error => {
        this.isloading = false;
        this.unblockDocument();
        console.log(error);
      }
    );
  }

  pageChanged($event: any) {
    this.filterModel.pageNumber = $event.page;
    this.currentPage = $event.page;
    this.LifelineClaimSummaryReports();
  }

  sort(sortBy: any) {
    this.upDowCompanyNameCSS = '';
    this.upDowYearsCSS = '';
    this.upDowMonthsCSS = '';
    this.upDowTotalCountCSS = '';
    this.upDowTotalAmountCSS = '';
    this.upDowStateCSS = '';

    if (!this.isAscending) {
      this.isAscending = true;
      this.filterModel.orderBy = sortBy + ' DESC';

      if (sortBy === "companyName") {
        this.upDowCompanyNameCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "years") {
        this.upDowYearsCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "months") {
        this.upDowMonthsCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "totalCount") {
        this.upDowTotalCountCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "totalAmount") {
        this.upDowTotalAmountCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "state") {
        this.upDowStateCSS = 'fa fa-arrow-down';
      }
    }
    else {
      this.isAscending = false;
      this.filterModel.orderBy = sortBy;

      if (sortBy === "companyName") {
        this.upDowCompanyNameCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "years") {
        this.upDowYearsCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "months") {
        this.upDowMonthsCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "totalCount") {
        this.upDowTotalCountCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "totalAmount") {
        this.upDowTotalAmountCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "state") {
        this.upDowStateCSS = 'fa fa-arrow-up';
      }

    }
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.LifelineClaimSummaryReports();
  }

  GetMonths() {
    this.dropdownSettingMonths = {
      singleSelection: false,
      text: 'Filter by Month',
      enableSearchFilter: true,
      classes: 'borderLessTextBoxGreen',
      badgeShowLimit: 1,
      noDataLabel: 'No Month',
      showCheckbox: true,
      enableFilterSelectAll: false
    };
    this.dropdownMonths.push({ 'id': 1, 'itemName': 'January' });
    this.dropdownMonths.push({ 'id': 2, 'itemName': 'February' });
    this.dropdownMonths.push({ 'id': 3, 'itemName': 'March' });
    this.dropdownMonths.push({ 'id': 4, 'itemName': 'April' });
    this.dropdownMonths.push({ 'id': 5, 'itemName': 'May' });
    this.dropdownMonths.push({ 'id': 6, 'itemName': 'June' });
    this.dropdownMonths.push({ 'id': 7, 'itemName': 'July' });
    this.dropdownMonths.push({ 'id': 8, 'itemName': 'August' });
    this.dropdownMonths.push({ 'id': 9, 'itemName': 'September' });
    this.dropdownMonths.push({ 'id': 10, 'itemName': 'October' });
    this.dropdownMonths.push({ 'id': 11, 'itemName': 'November' });
    this.dropdownMonths.push({ 'id': 12, 'itemName': 'December' });
  }

  removeElemetninArrayById(array, element) {
    return array.filter(e => e.id !== element);
  }

  onSelectedMonths($event) {

    if (this.listOfMonths.length > 0) {
      this.listOfMonths = this.listOfMonths.filter(m => m != $event.id);
    }

    this.listOfMonths.push($event.id);
    this.currentPage = 1;
    this.filterModel.pageNumber = '1'
    if (this.listOfMonths.length == 0)
      this.filterModel.months = '0';
    else
      this.filterModel.months = this.listOfMonths.join(',')
    this.LifelineClaimSummaryReports();
  }

  onDeSelectedMonths($event) {

    if (this.listOfMonths != null) {
      if (this.listOfMonths.length > 0) {
        this.listOfMonths = this.listOfMonths.filter(m => m != $event.id);
      }
    }
    this.currentPage = 1;
    this.filterModel.pageNumber = '1'
    if (this.listOfMonths.length == 0)
      this.filterModel.months = '0';
    else
      this.filterModel.months = this.listOfMonths.join(',')
    this.LifelineClaimSummaryReports();
  }

  onSelectAllMonths($event) {

    for (const item of $event) {
      if (this.listOfMonths != null) {
        if (this.listOfMonths.length > 0) {
          this.listOfMonths = this.listOfMonths.filter(m => m != item.id);
          this.listOfMonths.push(item.id);
        }
        else {
          this.listOfMonths.push(item.id);
        }
      }
    }
    this.currentPage = 1;
    this.filterModel.pageNumber = '1'
    if (this.listOfMonths.length == 0)
      this.filterModel.months = '0';
    else
      this.filterModel.months = this.listOfMonths.join(',')
    this.LifelineClaimSummaryReports();
  }

  onDeSelectAllMonths($event) {
    this.listOfMonths = [];
    this.currentPage = 1;
    this.filterModel.pageNumber = '1'
    this.filterModel.months = '0'
    this.LifelineClaimSummaryReports();
  }

  GetYears() {
    this.nladClaimService.GetLifelineClaimYears(this.tokenKey, this.filterModel).subscribe(
      data => {
        if (data != null) {
          let dropdownYears = data['listOfData'];
          if (dropdownYears != null) {
            if (dropdownYears.length > 0) {

              for (let iCounter = 0; iCounter < dropdownYears.length; iCounter++) {
                this.dropdownYears.push({ 'id': dropdownYears[iCounter], 'itemName': dropdownYears[iCounter] });
              }
            }
          }
          this.dropdownSettingYears = {
            singleSelection: false,
            text: 'Filter by Year',
            enableSearchFilter: true,
            classes: 'borderLessTextBoxGreen',
            badgeShowLimit: 1,
            noDataLabel: 'No Year',
            showCheckbox: true,
            enableFilterSelectAll: false
          };
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  onSelectedYears($event) {
    if (this.listOfYears.length > 0) {
      this.listOfYears = this.listOfYears.filter(m => m != $event.id);
    }
    this.listOfYears.push($event.id);
    this.currentPage = 1;
    this.filterModel.pageNumber = '1'
    if (this.listOfYears.length > 0)
      this.filterModel.years = this.listOfYears.join(',')
    else
      this.filterModel.years = '0';
    this.LifelineClaimSummaryReports();
  }

  onDeSelectedYears($event) {
    if (this.listOfYears != null) {
      if (this.listOfYears.length > 0) {
        this.listOfYears = this.listOfYears.filter(m => m != $event.id);
      }
    }
    this.currentPage = 1;
    this.filterModel.pageNumber = '1'
    if (this.listOfYears.length > 0)
      this.filterModel.years = this.listOfYears.join(',')
    else
      this.filterModel.years = '0';
    this.LifelineClaimSummaryReports();
  }

  onSelectAllYears($event) {
    for (const item of $event) {
      if (this.listOfYears != null) {
        if (this.listOfYears.length > 0) {
          this.listOfYears = this.listOfYears.filter(m => m != item.id);
          this.listOfYears.push(item.id);
        }
        else {
          this.listOfYears.push(item.id);
        }
      }
    }
    this.currentPage = 1;
    this.filterModel.pageNumber = '1'
    if (this.listOfYears.length > 0)
      this.filterModel.years = this.listOfYears.join(',')
    else
      this.filterModel.years = '0';
    this.LifelineClaimSummaryReports();
  }

  onDeSelectAllYears($event) {
    this.listOfYears = [];
    this.currentPage = 1;
    this.filterModel.pageNumber = '1'
    this.filterModel.years = '0'
    this.LifelineClaimSummaryReports();
  }

  setMonthsText(id) {
    return this.monthText.filter(m => m.id == id)[0].itemName;
  }

  GetInrollClientCompany() {
    this.nladClaimService.GetLifelineInrollClientCompanyV2().subscribe(
      data => {
        this.dropdownSettingCompanies = {
          singleSelection: true,
          text: 'Select by Company',
          enableSearchFilter: true,
          classes: 'borderLessTextBoxGreen',
          badgeShowLimit: 1,
          noDataLabel: 'No company',
          showCheckbox: false,
          enableFilterSelectAll: false
        };

        if (data != null) {
          if (data.status == 'Success') {
            this.listOfInrollProductCompany = data.listofInrollCompany;
            if (this.listOfInrollProductCompany != null) {
              if (this.listOfInrollProductCompany.length > 0) {
                for (let iCounter = 0; iCounter < this.listOfInrollProductCompany.length; iCounter++) {
                  this.dropdownCompanies.push({ 'id': this.listOfInrollProductCompany[iCounter].companyId, 'itemName': this.listOfInrollProductCompany[iCounter].companyName });
                }
              }
            }
          }
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  onSelectedCompanies($event) {

    this.listOfCompany = this.removeElemetninArrayById(this.listOfCompany, $event.id)
    this.listOfCompany.push($event.id);
    this.currentPage = 1;
    this.filterModel.pageNumber = '1';
    this.filterModel.providerId = $event.id;
    this.LifelineClaimSummaryReports();
  }

  onDeSelectedCompanies($event) {
    if (this.listOfCompany != null) {
      if (this.listOfCompany.length > 0) {
        this.listOfCompany = this.removeElemetninArrayById(this.listOfCompany, $event.id)
      }
    }
    this.currentPage = 1;
    this.filterModel.pageNumber = '1';
    this.filterModel.providerId = $event.id;
    this.LifelineClaimSummaryReports();
  }

  onSelectAllCompanies($event) {
    for (const item of $event) {
      if (this.listOfCompany != null) {
        if (this.listOfCompany.length > 0) {
          this.listOfCompany = this.removeElemetninArrayById(this.listOfCompany, item.id)
          this.listOfCompany.push(item.id);
        }
        else {
          this.listOfCompany.push(item.id);
        }
      }
    }
    this.currentPage = 1;
    this.filterModel.pageNumber = '1';
    this.filterModel.providerId = $event[0].id;
    this.LifelineClaimSummaryReports();
  }

  onDeSelectAllCompanies($event) {
    this.listOfCompany = [];
    this.currentPage = 1;
    this.filterModel.pageNumber = '1';
    this.filterModel.providerId = '0';
    this.LifelineClaimSummaryReports();
  }

  GetClaimState() {
    this.nladClaimService.GetClaimLifelineState(this.tokenKey).subscribe(
      data => {
        if (data != null) {
          this.listOfStateData = data['listOfData'];
          if (this.listOfStateData != null) {
            if (this.listOfStateData.length > 0) {

              for (let iCounter = 0; iCounter < this.listOfStateData.length; iCounter++) {
                this.dropdownStates.push({ 'id': this.listOfStateData[iCounter].shortName, 'itemName': this.listOfStateData[iCounter].name });
              }
            }
          }
          this.dropdownSettingStates = {
            singleSelection: false,
            text: 'Filter by State',
            enableSearchFilter: true,
            classes: 'borderLessTextBoxGreen',
            badgeShowLimit: 1,
            noDataLabel: 'No State',
            showCheckbox: true,
            enableFilterSelectAll: false
          };
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  onSelectedStates($event) {

    if (this.listOfStates.length > 0) {
      this.listOfStates = this.listOfStates.filter(m => m != $event.id)
    }
    this.listOfStates.push($event.id);
    this.currentPage = 1;
    this.filterModel.pageNumber = '1';
    if (this.listOfStates.length > 0)
      this.filterModel.state = this.listOfStates.join(',');
    else
      this.filterModel.state = '0';
    this.LifelineClaimSummaryReports();
  }

  onDeSelectedStates($event) {

    if (this.listOfStates != null) {
      if (this.listOfStates.length > 0) {
        this.listOfStates = this.listOfStates.filter(m => m != $event.id)
      }
    }
    this.currentPage = 1;
    this.filterModel.pageNumber = '1';
    if (this.listOfStates.length > 0)
      this.filterModel.state = this.listOfStates.join(',');
    else
      this.filterModel.state = '0';
    this.LifelineClaimSummaryReports();
  }

  onSelectAllStates($event) {

    for (const item of $event) {
      if (this.listOfStates != null) {
        if (this.listOfStates.length > 0) {
          this.listOfStates = this.listOfStates.filter(m => m != item.id)
          this.listOfStates.push(item.id);
        }
        else {
          this.listOfStates.push(item.id);
        }
      }
    }
    this.currentPage = 1;
    this.filterModel.pageNumber = '1';
    if (this.listOfStates.length > 0)
      this.filterModel.state = this.listOfStates.join(',');
    else
      this.filterModel.state = '0';
    this.LifelineClaimSummaryReports();
  }

  onDeSelectAllStates($event) {
    this.listOfStates = [];
    this.currentPage = 1;
    this.filterModel.pageNumber = '1';
    this.filterModel.state = '';
    this.LifelineClaimSummaryReports();
  }

  redirectToDetailsPage(years: any, months: any, ProviderId: any, state: any) {

    state = state == null ? "0" : state;
    months = months == null ? "0" : months;
    years = years == null ? "0" : years;

    let companyName = this.listOfInrollProductCompany.filter(m => m.companyId == ProviderId)[0].companyName;

    sessionStorage.setItem('DetailReportsYear', years);
    sessionStorage.setItem('DetailReportsMonths', months);
    sessionStorage.setItem('DetailReportsProviderId', ProviderId);
    sessionStorage.setItem('DetailReportsCompanyName', companyName);
    sessionStorage.setItem('DetailReportsState', state);
    sessionStorage.setItem('ReportFlag', 'Summary');
    this.router.navigate(['/admin/inroll/claim/details/lifeline-reports']);
  }

  blockDocument() {
    this.isShowprogressSpinner = true;
    this.blockedDocument = true;
  }

  unblockDocument() {
    this.isShowprogressSpinner = false;
    this.blockedDocument = false;
  }

  toggleMenu(index: number) {
    this.openMenuIndex = this.openMenuIndex === index ? -1 : index; // Toggle the menu
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.kebab-menu')) {
      this.openMenuIndex = null;
    }
  }

  ExportLifelineClaimSummary() {
    this.blockDocument()
    this.listOfExportData = [];
    this.isloading = true;
    this.filterModel.IsExport = true;
    this.nladClaimService.LifelineClaimSummaryReports(this.tokenKey, this.filterModel).subscribe(
      data => {
        if (data != null) {
          this.listOfExportData = data['listOfData'];
          if (this.listOfExportData != null) {
            if (this.listOfExportData.length > 0) {
              setTimeout(() => {
                this.DownloadLifelineClaimSummary();
                this.isloading = false;
                this.unblockDocument();
              }, 2000);
            }
            else {
              this.isloading = false;
              this.unblockDocument();
              this.toastr.error("No record found", "Error");
            }
          }
          else {
            this.isloading = false;
            this.unblockDocument();
            this.toastr.error("No record found", "Error");
          }
        }
      },
      error => {
        this.isloading = false;
        this.unblockDocument();
        console.log(error);
      }
    );
  }

  DownloadLifelineClaimSummary() {
    let tableData = document.getElementById("ExportTable").innerHTML;

    var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body>{table}</body></html>'
      , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
    let html = "<table><tr class='mainhead'> <td colspan='3'>";
    html += tableData;
    html += "</td></tr></table>";
    let name = 'ExportInrollLifelineClaimSummary';
    var ctx = { worksheet: name || 'Worksheet', table: html }
    FileSaver.saveAs((uri + base64(format(template, ctx))), "ExportInrollLifelineClaimSummary.xls");
  }
}
